import { FC } from "react";
import { Link, LinkProps } from "@mui/material";

import { useNavigate } from "react-router-dom";

export interface NavLinkProps extends Omit<LinkProps, "onClick" | "underline"> {
  linkTo?: string;
  onClick?: () => void;
}

const NavLink: FC<NavLinkProps> = (props) => {
  const { linkTo, onClick, ...rest } = props;
  const navigate = useNavigate();

  const onLinkClick = () => {
    if (linkTo) {
      navigate(linkTo);
      return;
    }
    onClick?.();
  };

  return (
    <Link
      underline="none"
      {...rest}
      sx={{
        cursor: "pointer",
      }}
      onClick={onLinkClick}
    />
  );
};

export default NavLink;
